import React, { useState, useMemo, useEffect } from "react";
import dayjs from "dayjs";
import {
    Box,
    FormControl,
    MenuItem,
    Select,
    Checkbox,
    ListItemText,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    InputLabel,
    OutlinedInput,
    Button,
    Typography,
    CircularProgress,
    TextField,
    useTheme,
    Paper
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";

import { DataGrid } from "@mui/x-data-grid";
import { skipToken } from "@reduxjs/toolkit/query/react";
import { useGetTopicSummaryQuery } from "../../../../features/market_pulse/marketPulseApiSlice";
import { tokens } from "../../../../theme";

import MarketPulseTrends from "../widgets/MarketPulseTrends";
import DailyTopicsList from "../widgets/DailyTopicsList";





const DailyTab = ({ rows = [], loading, date, onDateChange }) => {




    /* UI ------------------------------------------------------------------- */
    return (
        <>
            <MarketPulseTrends />
            <DailyTopicsList
                rows={rows}
                loading={loading}
                date={date}
                onDateChange={onDateChange}
            />
        </>
    );
};

export default DailyTab;
